import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

type Props = PropsWithClassName<{
  type: 'horizontal' | 'vertical';
}>;

const Divider = ({ type, className }: Props) => {
  if (type === 'horizontal') {
    return (
      <div
        className={cn('w-full h-[1px] bg-gdt-gray-6', className)}
        role="none"
      />
    );
  }

  return (
    <div
      className={cn('h-full w-[1px] bg-gdt-gray-6', className)}
      role="none"
    />
  );
};

export default Divider;
